/* eslint-disable quotes */
export default {
  AWAY_TIME: '時',
  COMMON__MINUTES: '分',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: '修正',
    BUTTON__DELETE: '削除',
    MESSAGE_STATUS__DELETE: '削除',
    MESSAGE_MENU__DELETE: '削除',
    BUTTON__SAVE: '保存',
    BUTTON__CLOSE: '閉じる',
    BUTTON__CANCEL: '取り消し',
    CHANNEL_SETTING__PROFILE__EDIT: '編集',
    MESSAGE_INPUT__PLACE_HOLDER: '入力してください',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'アップロード',
    EDIT_PROFILE__IMAGE_UPLOAD: 'アップロード',
    CHANNEL_LIST__TITLE: 'チャンネル',
    MESSAGE_MENU__COPY: 'コピー',
    CHANNEL_SETTING__HEADER__TITLE: 'チャンネル情報',
    MODAL__USER_LIST__TITLE: 'メンバー',
    CHANNEL_SETTING__MEMBERS__TITLE: 'メンバー',
    NO_MEMBERS: '(空いているチャンネル)',
    NO_NAME: '(不明なユーザー)',
    TOOLTIP__UNKOWN_USER: '(不明なユーザー)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'チャンネルを出る',
    BUTTON__INVITE: '招待',
    MODAL__INVITE_MEMBER__SELECTED: '選択済み',
    MODAL__CREATE_CHANNEL__SELECTED: '選択済み',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'チャンネル名',
    MODAL__INVITE_MEMBER__TITLE: 'メンバー追加',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: '入力',
    BUTTON__CREATE: '作成する',
    MODAL__CREATE_CHANNEL__TITLE: '新しいチャンネル',
    TRYING_TO_CONNECT: '接続を試みています…',
    USER_PROFILE__MESSAGE: 'メッセージ',
    USER_PROFILE__USER_ID: '使用者ID',
    EDIT_PROFILE__USERID_LABEL: '使用者ID',
    EDIT_PROFILE__TITLE: '自分のプロフィール',
    EDIT_PROFILE__IMAGE_LABEL: 'プロフィールイメージ',
    EDIT_PROFILE__NICKNAME_LABEL: 'ニックネーム',
    EDIT_PROFILE__THEME_LABEL: 'ダークテーマ',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'このチャンネルでチャットをすることはできません。',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'ここまで既読',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'アクティブ',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: '全体のメンバー',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: '使用者を招待',
    MODAL__DELETE_MESSAGE__TITLE: 'このメッセージを削除しますか？',
    MODAL__CHANNEL_INFORMATION__TITLE: 'チャンネル情報の編集',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'チャンネルイメージ',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: '名前を入力してください。',
    TYPING_INDICATOR__IS_TYPING: '入力中…',
    TYPING_INDICATOR__ARE_TYPING: '入力中…',
    TYPING_INDICATOR__MULTIPLE_TYPING: '入力中…',
    TYPING_INDICATOR__AND: 'と',
    MESSAGE_STATUS__SENDING_FAILED: 'メッセージを転送できません。',
    MESSAGE_STATUS__TRY_AGAIN: '再度行ってください。',
    MESSAGE_STATUS__OR: '又は',
    PLACE_HOLDER__WRONG: 'エラーが発生しました。',
    PLACE_HOLDER__RETRY_TO_CONNECT: '再試行',
    NO_TITLE: '題名無し',
    TOOLTIP__AND_YOU: '、と自分',
    TOOLTIP__YOU: '自分',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(不明なメッセージ)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'このメッセージを読むことができません。',
    MESSAGE_EDITED: '(編集済み)',
    PLACE_HOLDER__NO_CHANNEL: '新しい対話を始めてください。',
    MESSAGE_MENU__REPLY: '返信',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: '自分',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: '返信する',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: '確認',
  SETTINGS__NONE: '無し',
  SEARCH__NO_RESULT: '検索結果がありません。',
  LOGIN__PASSWORD: 'パスワード',
  SEARCH__USER_PLACEHOLDER: '名前/社員番号/携帯番号で検索',
  BASIC__: {
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: '自分の出退勤履歴の照会権限',
    ERROR: 'エラーが発生しました。<br /> しばらく時間をおいてから再度行ってください。',
    MSG__: { INPUT: 'キーワードを入力してください。' },
    PWD_ALL_VALIDATION: '%1$@~%2$@文字のアルファベット大文字/小文字、数字、特殊文字を組み合わせて設定してください。',
    RETRY: '再度行う',
    PASSWORD_RULE: '8-20字のアルファベットの大文字・小文字、数字、特殊文字の組み合わせ',
  },
  SEARCH__NO_USER_INFO: 'ユーザー情報がありません。',
  LOGIN__EMAIL_OR_HP: 'メールアドレス又は電話番号',
  BASIC__SEARCH: '検索',
  ELECTRON: {
    MENU_DELETE: '削除',
    MENU_VIEW: '見る',
    MENU_SIGN_OUT: 'ログアウト',
    MENU_SETTINGS: '設定',
    MENU_CLOSE: '閉じる',
    MENU_EDIT: '編集',
    MENU_SELECT_ALL: '全体を選択',
    MENU_COPY: 'コピー',
    MENU_FILE: 'ファイル',
    MENU_ABOUT: '{0} 情報',
    MENU_UPDATE: 'アップデートの確認',
    MENU_HIDE: '{0} 隠す',
    MENU_HIDE_OTHERS: '他のアプリを隠す',
    MENU_SHOW_ALL: '全て見せる',
    MENU_QUIT: '{0} 終了',
    MENU_NEW_CHANNEL: '新しいチャンネル',
    MENU_UNDO: '実行キャンセル',
    MENU_REDO: '再度実行',
    MENU_CUT: 'カット',
    MENU_PASTE: '貼り付ける',
    MENU_PASTE_AND_MATCH_STYLE: 'スタイルを貼り付ける',
    MENU_RELOAD: '再度読み込んで表示',
    MENU_FORCE_RELOAD: '強制的に読み込んで表示',
    MENU_FULL_SCREEN: '全体画面に転換',
    MENU_RESET_ZOOM: '実際の大きさ',
    MENU_ZOOM_IN: '拡大',
    MENU_ZOOM_OUT: '縮小',
    MENU_WINDOW: 'タブ',
    MENU_MINIMIZE: '最小化',
    MENU_ZOOM: '最大化',
    MENU_HELP: 'ヘルプ',
    MESSAGE_UP_TO_DATE: '現在、最新バージョンを使用中です。',
    UPDATE_AVAILABLE: 'アップデート可能',
    MESSAGE_UPDATE_AVAILABLE: '最新バージョンにアップデートできます。',
    UP_TO_DATE: '最新バージョン',
  },
  LOGIN__INSERT_EMAIL_HP: 'メールアドレス又は電話番号を入力してください。',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'パスワードを忘れてしまった場合、モバイルアプリのログインページでパスワードを再設定してください。',
  LOGIN__INSERT_PASSWORD: 'パスワードを入力してください。',
  LOGIN__PASSWORD_INFORMATION: 'パスワードをお忘れですか？',
  BEFORE: '既存',
  ALERT__NO_ONE_SELECTED: '選択した従業員がいません。',
  LOGOUT: 'ログアウト',
  LOGIN: 'ログイン',
  COMMON__SECONDS: '秒',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: '編集を中断する場合、修正された内容は保存されません。',
      ARE_YOU_SURE_WANT_TO_STOP: 'スケジュールの編集を中断しますか？',
    },
  },
  TEMPLATE__: {
    GUIDE__: {
      NO_TEMPLATE_REGISTERED: '登録されているテンプレートがありません。',
    },
  },
  SETTINGS__CHANGE_LANGUAGE: '言語設定',
  SEARCH__MEMBER_PLACEHOLDER: '名前/社員番号/電話番号',
  MSG__: {
    BASIC__: { NO_SEARCH_RESULT: '結果がありません。' },
    ERROR__: {
      CREATE_CHANNEL: 'チャンネルを開設できません。',
      UPDATE_CHANNEL_INFO: 'チャンネルをアップデートすることができません。',
      LEAVE_CHANNEL: 'チャンネルを出ることができません。',
    },
    FILE__: { MAXIMGSIZE: '最大ファイルサイズの25MBを超過しました。' },
    ALLOW_BROWSER_ALARM: 'ブラウザ設定からお知らせを許可するとお知らせメッセージを確認することができます。',
    LABEL__: { SEARCH_MESSAGE: 'メッセージ検索' },
    GUIDE__: {
      SEARCH_MESSAGE: '{0}から探したいメッセージ内容を検索してください。',
    },
  },
  BASIC__UNKNOWN: '不明',
  LOGIN__SERVER_ALERT: 'サーバーに繋ぐことができません。',
  INVITE__MEMBER_SELECTION: 'メンバー選択',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: '変更された名前は全てメンバーに見えるようになります。',
  NOTICE: '通知',
  INVITE__CREATE: '作成する',
  CHANNEL__LEAVE_THIS_CHANNEL: 'チャンネルを出ますか？',
  LOGIN__PASSWORD_FAIL_COUNT: 'パスワードを{0}回間違えました。',
  LOGIN__FAIL_ALERT: '５回連続で間違えた場合、５分間ロックがかかります。',
  LOGIN__LOCK_STATE_ALERT: 'パスワードが連続で間違えたので５分間ロックがかかりました。',
  LOGIN__RETRY_ALERT: '{0}後に再度行ってください。',
  LOGIN__PASSWORD_GUIDE_TITLE: 'ShoplChatのパスワードはモバイルアプリのパスワードを同じです。',
  SETTINGS__ALL_MESSAGES: '新しいメッセージ全てに通知',
  SETTINGS__ALARM_SOUND: 'サウンド',
  SETTINGS__SOUND_ALARM: '通知オン',
  SETTINGS__LISTEN_ALARM_SOUND: '聴く',
  ALERT__MAX_INVITE_MEMBER: 'チャンネルに参加できる最大人員数は20,000人です。',
  LOGIN__DEACTIVATED_ALERT: '管理者がチャット機能を非アクティブにしてログインすることはできません。',
  LOGIN__SERVER_ALERT_CONTENTS:
    'ネットワークが不安定なため、ログインできません。インターネットの接続を確認し、再度行ってください。',
  LOGIN__LOGOUT_ALERT: 'ログアウトされました。',
  CHANNEL__EDIT_CHANNEL_NAME: 'チャンネル名変更',
  SETTINGS__THEME: 'テーマ',
  SETTINGS__LANGUAGE: '言語',
  SETTINGS__LIGHT_THEME: 'ライト',
  SETTINGS__DARK_THEME: 'ダークテーマ',
  SEARCH__CHANNEL_PLACEHOLDER: '従業員名',
  CHANNEL__CONTACT: '1:1 チャット',
  BASIC: { LABEL: { MAXIMAGECNT: '写真は最大{0}枚まで登録できます。' } },
  LOGIN__LOGIN_FAILED: 'IDまたはパスワードが間違って入力されました。',
  FORGOT_PW: 'パスワードをお忘れですか？',
  BASIC__MAX_FORMAT_INPUT: '最大%@字まで入力できます。',
  SERVICE__COMING_SOON: 'まもなく提供予定です。',
  LOGIN__GUIDE: 'アプリで使用しているアカウントでログインが可能です。',
  MOBILE__: {
    ACCESS_PC: 'ダッシュボード(PC)はPCで接続してください！',
    ACCESS_DESC_01: 'ダッシュボード(PC)はPC環境に最適化されています。',
    ACCESS_DESC_02: '円滑に使用できるようにPCで接続してください。',
    ACCESS_PC_ONLY: 'PCで接続してください！',
    GUIDE: 'チャット機能はPC又はモバイルアプリで使用することができます。',
  },
  CHANNEL__NO_CHAT_HISTORY: '対話履歴がありません。',
};
